<template>
    <DModal
        is-confirm
        is-small
        is-error
        :title="__('customers.customers.cloudpit_password_reset_modal_title')"
        :message="__('customers.customers.cloudpit_password_reset_modal_message')"
        :show="showModal"
        @confirm="confirm"
        @close="close"
    />
</template>

<script>
export default {
    name: 'ResetPasswordModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirm', 'close'],
    methods: {
        confirm () {
            this.$emit('confirm')
        },
        close () {
            this.$emit('close')
        }
    }
}
</script>
